import React, { useState, useContext } from "react";
import PropTypes from "prop-types";

import { addDays } from "date-fns";
import {
  ALL_EMPLOYEE_CERTIFICATIONS_BY_PAGE_VIEW_QUERY
  // ALL_EMPLOYEE_CERTIFICATIONS_BY_PAGE_QUERY
} from "../../../graphql/EmployeeCertifications/EmployeeCertifications.graphql";

import { ModalContext } from "../../../components/ModalProvider";

import {
  AddEmployeeCertificationForm,
  EditEmployeeCertificationForm
} from "../../../components/Employees";

import DataTable from "../../../components/DataTable";

import { COLUMNS } from "./columns";

import PageHeader from "../../../components/PageHeader";

import EmployeeCertificationFilters from "./EmployeeCertificationFilters";
import { getFilterState, saveFilterState } from "../../../utils";

const EmployeeCertificationsPage = ({ readOnly }) => {
  const INITIAL_FILTER_STATE = getFilterState("CERTIFICATION_FILTERS", {
    CertificationTypeRecIdRef_not: 45,
    ExpirationDate_gte: addDays(new Date(), -90),
    minDaysToExpire: -90,
    EmployeeTypeRecIdRef: null,
    Active: true
  });

  const [filters, setFilters] = useState(INITIAL_FILTER_STATE);
  const handleSetFilters = inputs => {
    saveFilterState("CERTIFICATION_FILTERS", inputs);
    setFilters({ ...inputs });
  };
  const resetFilters = () =>
    handleSetFilters({
      CertificationTypeRecIdRef_not: 45,
      ExpirationDate_gte: addDays(new Date(), -90)
    });
  const { setModalOpen } = useContext(ModalContext);

  const filteredFilters = {
    EmployeeRecIdRef: filters.EmployeeRecIdRef,
    State: filters.State,
    Active: filters.Active,
    ExpirationDate_lte: filters.ExpirationDate_lte,
    ExpirationDate_gte: filters.ExpirationDate_gte,
    CertificationTypeRecIdRef: filters.CertificationTypeRecIdRef,
    CertificationTypeRecIdRef_not: filters.CertificationTypeRecIdRef_not
  };

  return (
    <React.Fragment>
      <PageHeader
        FilterComponent={EmployeeCertificationFilters}
        columns={COLUMNS}
        filters={filters}
        name="VW_EmployeeCertificationsByPage"
        query={ALL_EMPLOYEE_CERTIFICATIONS_BY_PAGE_VIEW_QUERY}
        readOnly={readOnly}
        resetFilters={resetFilters}
        setFilters={handleSetFilters}
        title="Employee Certifications"
        where={filteredFilters}
        onAddClick={() =>
          setModalOpen(
            true,
            <AddEmployeeCertificationForm
              onComplete={() => setModalOpen(false, "")}
            />
          )
        }
      />
      <DataTable
        isPaginated
        columns={COLUMNS}
        dataQuery={ALL_EMPLOYEE_CERTIFICATIONS_BY_PAGE_VIEW_QUERY}
        initialSortBy={[{ id: "ExpirationDate", desc: false }]}
        name="VW_EmployeeCertificationsByPage"
        where={filteredFilters}
        onRowClick={data =>
          !readOnly
            ? setModalOpen(
                true,
                <EditEmployeeCertificationForm
                  certification={data}
                  onComplete={() => setModalOpen(false, "")}
                />
              )
            : {}
        }
      />
    </React.Fragment>
  );
};

EmployeeCertificationsPage.propTypes = {
  readOnly: PropTypes.bool
};
EmployeeCertificationsPage.defaultProps = {
  readOnly: false
};

export default EmployeeCertificationsPage;
